
    import { computed, defineComponent, PropType } from 'vue'
    import type { BlogPosting, NewsArticle, WithContext } from 'schema-dts'
    import type { Location } from 'vue-router'
    import { useRouter } from 'vue-router/composables'

    import { postPreview } from '@/common/json-ld/posts'
    import { Post } from '@/common/models/data/dashboard/posts/post'

    export default defineComponent({
        props: {
            post: {
                type: Object as PropType<Post>,
                required: true
            }
        },
        setup (props) {
            const router = useRouter()

            const route = computed<Location>(() => {
                return {
                    name: `${props.post.type.type}.by-slug`,
                    params: {
                        slug: props.post.slug
                    }
                }
            })

            const jsonLd = computed<WithContext<NewsArticle> | WithContext<BlogPosting>>(() => {
                return postPreview(props.post, router.resolve(route.value).href)
            })

            return {
                jsonLd,
                route
            }
        }
    })
